module.exports = __webpack_public_path__ + "img/about_back.0ff59a3f.jpg";